var escape = require("../../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CookiesMessage{width:100%;position:fixed;bottom:0;background:#666;min-height:50px;padding:20px 50px;color:#fff;margin:0;display:flex;align-items:center}.CookiesMessage .btn-primary{background-color:#00adff;border-color:#00adff;color:#fff;border-radius:20px;margin-left:10px}.CookiesMessage .btn-primary:hover{background-color:#fff;color:#00adff}.CookiesMessage .close{position:absolute;right:15px;color:#fff;top:15px;background:url(" + escape(require("../../../_static/images/crossQuestion.svg")) + ") 50% no-repeat!important;width:19px;height:15px;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/common/Footer/Cookies.scss
// module id = 2424
// module chunks = 0